import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Pipe({
    name: 'momentDate',
})
export class MomentDatePipe extends DatePipe implements PipeTransform {
    transform(value: Date | string | number, format?: string, timezone?: string): any {
        const timezoneOffSet = moment.tz(value, timezone).format('Z');
        return super.transform(value, format, timezoneOffSet);
    }
}
